/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import styled, { css } from "styled-components";

const Stack = styled.div`
  display: grid;
  gap: ${({ $gap }) => $gap || "0.5rem"};
  ${({ $align }) => $align && css`justify-items: ${$align};`}
  ${({ $padding }) => $padding && css`padding: ${$padding};`}
`;

export default Stack;
